module.exports = __webpack_public_path__ + "static/media/alpha_advisors_logo.90675602.jpg";